<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex w-full items-center p-4 pl-6">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <img class="w-28 brightness-0 invert" src="images/vazuvi/logo.svg" alt="VAZUVI" />
            </div>
            <!-- Components -->
            <div class="ml-auto flex items-center">
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <!-- User -->
        <div class="flex w-full flex-col items-center p-4">
<!--            <div class="relative h-24 w-24">-->
<!--                @if (user.avatar) {-->
<!--                    <img-->
<!--                        class="h-full w-full rounded-full"-->
<!--                        [src]="user.avatar"-->
<!--                        alt="User avatar"-->
<!--                    />-->
<!--                }-->
<!--                @if (!user.avatar) {-->
<!--                    <mat-icon-->
<!--                        class="icon-size-24"-->
<!--                        [svgIcon]="'heroicons_solid:user-circle'"-->
<!--                    ></mat-icon>-->
<!--                }-->
<!--            </div>-->
            <div class="mt-6 flex w-full flex-col items-center justify-center">
                <div
                    class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal"
                >
                    {{ user.name }}
                </div>
                <div
                    class="text-secondary mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center text-md font-medium leading-normal"
                >
                    {{ user.username }}
                </div>
            </div>
        </div>
        @if (!isAdmin && hasRelations) {
            <app-client-relation></app-client-relation>
        }
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <div
            class="mb-4 mt-2 flex h-16 flex-0 items-center justify-center pl-2 pr-6 opacity-12"
        >
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <div class="flex flex-1 items-center mx-5">
            <div class="h-13 w-full">
                <div class="flex flex-1 items-center justify-center h-full" *ngIf="displayClientModeWarning()">
                    <mat-icon class="icon-size-12 pt-1 text-red-500" [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
                    <h2 class="text-red-500 text-3xl font-medium mx-4">
                        TRYB WIDOKU KLIENTA
                    </h2>
                    <mat-icon class="icon-size-12 pt-1 text-red-500" [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>

                    <button mat-fab class="cursor-pointer bg-red-500 shadow-none h-10 w-30 ml-5" (click)="exitClientMode()">
                        <mat-icon class="icon-size-5 text-white" [svgIcon]="'heroicons_outline:x-circle'"></mat-icon>
                        <span class="p-3">Wyjdź</span>
                    </button>
                </div>
            </div>
        </div>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2" >
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->
</div>

